import React, { useEffect, useState, useContext } from 'react';
import { Col, Form, Radio, Row, Tabs, Modal, Table } from 'antd';
import { Input, Select, Checkbox, InfoBox, MobileTabBar } from 'components';
import BasketSummary from './basket-summary';

import ArrowRight from 'assests/icons/arrow-right';
import masterCard from 'assests/images/master-card.png';
import paycellLogo from 'assests/images/paycell-logo.png';
import cardFront from 'assests/images/card-front@2x.png';
import { DimensionsContext } from 'context/dimensions.context';
import { getMaxAmount, buyingViaCreditCardChecks, getVirtualInvoicesChecks, getVirtualInvoices, getPaycellMethodWithAlias } from 'services/omcc.service';
import { customMessages, customValidators } from 'utils';

import moment from 'moment';
import { useDispatch } from 'react-redux';
import { VIRTUAL_INVOICE_STATUS } from 'constants/mapping.const';
import { usePackage } from 'context/package.context';
import CreditCardRedirect from './credit-card-redirect';
import PaycellModal from './parts/paycell-modal';
import { VIRTUAL_PAYMENT_CONTENT } from 'constants/page.const';
import formatter from 'string-format';

const format = require('string-format');
const { TabPane } = Tabs;
const DummyMonths = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];


const columns = [
  {
    title: 'Fatura Numarası',
    dataIndex: 'faturaNO'
  },
  {
    title: 'Paket Adı',
    dataIndex: 'paketAdi'
  },
  {
    title: 'Oluşturulma Trh.',
    dataIndex: 'createTime',
    render: (text, record) => {
      return (
        record.createTime ? moment(record.createTime).format("DD.MM.YYYY") : '-'
      );
    }
  },
  {
    title: 'Ödeme Trh.',
    dataIndex: 'paidTime',
    render: (text, record) => {
      return (
        record.paidTime ? moment(record.paidTime).format("DD.MM.YYYY") : '-'
      );
    }
  },
  {
    title: 'Son Öd. Zm.',
    dataIndex: 'gecerlilikSuresi',
    render: (text, record) => {
      return (
        record.gecerlilikSuresi ? moment(record.gecerlilikSuresi).format("DD.MM.YYYY") : '-'
      );
    }
  },
  {
    title: 'Fatura Durumu',
    dataIndex: 'statu',
    render: (value) => {


      return (

        <span className="bill-status">{VIRTUAL_INVOICE_STATUS[value]} ({value})</span>
      )
    }
  }
];


const Payment = (props) => {
  const dispatch = useDispatch();
  const [selectedRadio, setSelectedRadio] = useState(0);
  const [selectedKey, setSelectedKey] = useState("1");
  const [cardNumber, setCardNumber] = useState('');
  const [cardName, setCardName] = useState('empty-card');
  const [renderTab, setRenderTab] = useState(true);

  const [tabIndex, setTabIndex] = useState("1")
  const [billCreated, setBillCreated] = useState(true)

  const [fraudMessage, setFraudMessage] = useState("");
  const [ccBuyPermit, setCCBuyPermit] = useState("");
  const [viBuyPermit, setVIBuyPermit] = useState("");
  var creditCardType = require('credit-card-type');
  const formRef = React.createRef();
  const [form] = Form.useForm();
  const { isPc } = useContext(DimensionsContext);
  const [arrayList, setArrayList] = useState([]);
  const [dummyYears, setDummyYears] = useState(['2021', '2022', '2023', '2024']);
  const [cardList, setCardList] = useState([]);
  const { triggerClick } = usePackage();
  function setCardType(cardNumber) {
    if (cardNumber.length > 3) {
      setCardName(creditCardType(cardNumber)[0] ? creditCardType(cardNumber)[0].type : 'empty-card');
    }

    if (cardNumber.match('^[0-9]+$') != null) {
      setCardNumber(cardNumber);
    } else {
      setCardNumber('');
    }
  }
  function callback(key) {
    setTabIndex(key);
    form.resetFields();
  }

  useEffect(() => {
    if (tabIndex == "2" && fraudMessage == "") {
      getMaxAmount().then((result) => {
        if (result.fraudDetected) {
          setFraudMessage(customMessages.getMessage("fraudError"));
        }
        else {
          result.totalValue = result.totalValue.toLocaleString('tr-TR');
          result.remainingValue = result.remainingValue.toLocaleString('tr-TR');
          setFraudMessage(format(customMessages.getMessage("fraudAmountMessage"), result));
        }
      }).catch((response) => {
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage(response.responseCode),
        });
      });
    }
    else if (tabIndex == "3") {
      getVirtualInvoicesChecks().then((result) => {
        setVIBuyPermit("true");
        getVirtualInvoices().then((result) => {
          setArrayList(result.properties.data);
          setBillCreated(result.properties.data.length > 0);
        }).catch((response) => {
          Modal.error({
            title: 'Hata',
            content: customMessages.getMessage(response.responseCode),
          });
        });
      }).catch((err) => {
        var errorMessage;
        if (err.responseCode == 894) {
          errorMessage = formatter(customMessages.getMessage(err.responseCode), err.properties.minAllowedContractDates)
        } else {
          errorMessage = customMessages.getMessage(err.responseCode)
        }
        setVIBuyPermit(errorMessage);
      }
      )

    }
    else if (tabIndex == "1" && ccBuyPermit == "") {
      buyingViaCreditCardChecks().then((result) => {
        setCCBuyPermit("true");

      }).catch((err) => {

        var errorMessage;
        if (err.responseCode == 1103 || err.responseCode == 1104 || err.responseCode == 1105) {
          errorMessage = formatter(customMessages.getMessage(err.responseCode), err.properties.maxUsage)
        } else if (err.responseCode == 893) {
          errorMessage = formatter(customMessages.getMessage(err.responseCode), err.properties.minAllowedContractDates)
        }
        else {
          errorMessage = customMessages.getMessage(err.responseCode)
        }
        setCCBuyPermit(errorMessage);
      });
    }

  }, [tabIndex]);



  function onGetPaycellMethodWithAlias() {

    getPaycellMethodWithAlias().then((result) => {
      setCardList(result.paymentMethodList);
    });

  }



  useEffect(() => {
    var cardName = 'empty-card';
    setRenderTab(isPc);
  }, []);


  useEffect(() => {
    onGetPaycellMethodWithAlias();
    const count = 10;
    let years = [];
    const startYear = new Date().getFullYear();
    for (let index = 0; index < 10; index++) {
      years.push(startYear + index);
    }
    setDummyYears(years);
  }, []);


  useEffect(() => {
    var cardName = 'empty-card';
    setRenderTab(isPc);
  }, [cardName, isPc]);

  return (
    <>
      <div className="container">
        <Form form={form} name="payment" ref={formRef}>
          <Row className="boxes-header">
            <h1 className="section__title">Ödeme Bilgileri</h1>
          </Row>
          <Row gutter={30}>
            <Col span={24} lg={16}>
              <div className="box margin-bottom-spacing-l">
                <Tabs
                  onChange={callback}
                  defaultActiveKey={tabIndex}
                  renderTabBar={(props, Item) => {
                    return isPc ? (
                      <Item {...props} />
                    ) : (
                      <MobileTabBar props={props} item={Item} />
                    );
                  }}
                >
                  <TabPane tab="Kredi Kartı ile Öde" key="1">
                    {
                      ccBuyPermit === "true" ?
                      <>
                        <Row>
                          <Col span={24}>
                            <span
                              style={{ lineHeight: '25px' }}
                              className="info-text--small margin-bottom-spacing-m"
                            >
                              <figure style={{ float: 'left' }}>
                                <img
                                  style={{ width: '65px', marginRight: '10px' }}
                                  src={paycellLogo}
                                  alt="Paycell Logo"
                                />
                              </figure>
                              Ödeme sistemimizde PAYCELL altyapısı kullanılmaktadır.
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={18}>
                            <span className="box__title--small">
                              Kart Seçimi Yapın
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24} md={18}>
                            <Form.Item initialValue={selectedRadio}
                              rules={[{ required: true }]}
                              name="paymentMethod"
                              messageVariables={{ label: 'paymentMethod' }}
                              className="margin-bottom-0"
                            >
                              <Radio.Group
                                className="radio-group--v2"
                                onChange={(e) => {
                                  setSelectedRadio(e.target.value);
                                }}
                                value={selectedRadio}
                              >


                                {cardList.map((item, index) => (
                                  <Radio value={item.paymentMethodID} key={item.paymentMethodID}>
                                    <div className="text-area">
                                      {item.alias} -  {item.paymentMethodNumber}
                                      <figure>
                                        <img src={masterCard} />
                                      </figure>
                                    </div>
                                    {(selectedRadio === item.paymentMethodID) ? (
                                      <Col xs={24} lg={8}>
                                        <Form.Item
                                          rules={[{ required: true }]}
                                          name="regiseterdCvc"
                                          messageVariables={{ label: 'CVV' }}
                                          className="margin-bottom-0"
                                        >
                                          <Input
                                            type="tel"
                                            name="number"
                                            label="cvc"
                                            maxLength={4}
                                          />
                                        </Form.Item>
                                      </Col>
                                    ) : null}
                                  </Radio>
                                ))}

                                <Radio value={0}>
                                  <div className="text-area">
                                    Başka Bir Kart İle Öde
                                    <figure>
                                      <img
                                        src={require(`assests/images/${cardName}.png`)}
                                        alt="Credit Card Image"
                                      />
                                    </figure>
                                  </div>
                                  {selectedRadio === 0 ? (
                                    <div>
                                      <Form.Item
                                        rules={[{ required: true }]}
                                        name="name"
                                        autoComplete="off"
                                        messageVariables={{ label: 'Ad Soyad' }}
                                        getValueFromEvent={(e) => {
                                          const matched = e.target.value.match(/^[a-zA-Z\sğüşöçİĞÜŞÖÇ]*$/);
                                          if (!matched) {
                                            return "";
                                          } else {
                                            return e.target.value;
                                          }
                                        }}
                                      >
                                        <Input
                                          label="Ad Soyad"
                                          name="number"
                                        />
                                      </Form.Item>
                                      <Form.Item
                                        rules={[{ required: true }]}
                                        name="cardNumber"
                                        //initialValue={'4090700090840057'}
                                        messageVariables={{ label: 'Kart Numarası' }}
                                      >
                                        <Input
                                          type="number"
                                          label="Kart Numarası"
                                          autoComplete="off"
                                          name="cardNumber" maxLength={20}
                                          value={cardNumber}
                                          onChange={(e) =>
                                            setCardType(e.target.value)
                                          }
                                        />
                                      </Form.Item>
                                      <Row gutter={20}>
                                        <Col xs={12} md={8}>
                                          <Form.Item
                                            rules={[{ required: true }]}
                                            name="month"
                                            //initialValue={'11'}
                                            messageVariables={{ label: 'Ay' }}
                                          >
                                            <Select
                                              label="Ay"
                                              data={DummyMonths}
                                            ></Select>
                                          </Form.Item>
                                        </Col>
                                        <Col xs={12} md={8}>
                                          <Form.Item
                                            rules={[{ required: true }]}
                                            name="year"
                                            // initialValue={'2022'}
                                            messageVariables={{ label: 'Yıl' }}
                                          >
                                            <Select
                                              label="Yıl"
                                              data={dummyYears}
                                            ></Select>
                                          </Form.Item>
                                        </Col>
                                        <Col xs={12} md={8}>
                                          <Form.Item
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  'Please enter CVC!',
                                              },
                                            ]}
                                            //initialValue={'592'}
                                            name="cvc"
                                            autoComplete="off"
                                            messageVariables={{ label: 'cvc' }}
                                          >
                                            <Input
                                              maxLength={4}
                                              type="tel"
                                              name="number"
                                              label="CVV2"
                                            />
                                          </Form.Item>
                                        </Col>
                                      </Row>
                                      <PaycellModal></PaycellModal>
                                    </div>
                                  ) : null}
                                </Radio>
                              </Radio.Group>
                            </Form.Item>
                          </Col>
                        </Row>
                        <figure className="card-front-image">
                          <img src={cardFront} alt="Card Front Image" />
                        </figure>
                      </> : <InfoBox type="warning" content={
                        ccBuyPermit
                      } />
                    }
                  </TabPane>
                  {props.userStatus.paymentType !== "PREPAID" && <TabPane tab="Turkcell Faturama Yansıt" key="2">
                    <InfoBox
                      type="warning"
                      htmlContent={fraudMessage
                      }
                    />
                  </TabPane>}
                  {props.userStatus.paymentType != "PREPAID" && <TabPane tab="Öde ve Kullan" key="3">
                    {
                      viBuyPermit == "true" ?
                        billCreated ?
                          <InfoBox type="warning" content={
                            <p><strong>“Öde Kullan”</strong> ile yaptığınız paket satın alımınız için ödenmemiş faturanız bulunmaktadır.
                              Faturanızı <b>{arrayList.length > 0 ? moment(arrayList[0].gecerlilikSuresi).format("DD.MM.YYYY HH:mm") : ''}</b> tarihine kadar ödemeniz gerekmektedir.
                              <br /> <b>Paket Adı : {arrayList.length > 0 ? arrayList[0].paketAdi : ''}</b></p>

                          } /> : VIRTUAL_PAYMENT_CONTENT
                        : <InfoBox type="warning" content={
                          viBuyPermit
                        } />
                    }
                  </TabPane>}
                </Tabs>
              </div>
              {(tabIndex == 3 && (billCreated || viBuyPermit != "true")) || (tabIndex == 1 && ccBuyPermit != "true" ) || (tabIndex == 2)  ? false : <>
                <InfoBox compClass="margin-bottom-spacing-l show-desktop"
                  htmlContent={props.userStatus.currentAgreement}
                />
              </>}

            </Col>


            {
              ((tabIndex == 1 && ccBuyPermit == "true") || (tabIndex == 3 && viBuyPermit == "true") || (tabIndex == 2)) ?
                <Col span={24} lg={8}>
                  <BasketSummary
                    visibility = {true}
                    agreement={props.userStatus.currentAgreement}
                    terms={props.userStatus.currentToS}
                    formRef={formRef}
                    title="Özet"
                    tabIndex={tabIndex}
                    setBillCreated={setBillCreated}
                    billCreated={billCreated}
                  />
                </Col> :
                ""
            }


            {/* 

               { billCreated ? false : 
                  <span className='info-text--small padding-top-spacing-m padding-top-spacing-m'>
                  Satın aldığınız paketler <strong>12 Ay</strong> süresince geçerli olacaktır. 
                  </span> 
                } */}

          </Row>
          {tabIndex == 3 && viBuyPermit === "true" && billCreated ? <div className="box box--small">
            <Table
              columns={columns}
              scroll={{ y: 610 }}
              dataSource={arrayList}
              className="table--guide table--bill "
              pagination={{ total: arrayList.length, position: ['bottomCenter'] }}
            />
          </div> : false}
        </Form>
        {(tabIndex == "1") &&
          <CreditCardRedirect

          />

        }
      </div>
    </>
  );
};

export default Payment;
